<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import { useStageStore } from "@/stores/stage";

import SvgCircle from '@/components/svg/SvgElement.vue'
import SvgPath from '@/components/svg/SvgPath.vue'

const formStore = useStageStore()
const router = useRouter()
const { t } = useI18n()

const connectorContainer = ref(null)
const svg = ref(null)
const svgNodes = ref([])
const connectors = ref(null)
const nodes = ref(null)

const stage = reactive({
  width: 600,
  height: 400
})


const showQuestion = (item) => {
  if (!item?.access?.map || !item.access.question || !item.access.questionAccessAllowedByRelations) {
    return;
  }

  if(formStore.getNumberOfGivenAnswers !== 0){
    router.push(`/${item.id}`)
  }

  document.querySelector('#app_public form').focus();
  formStore.showMap = false;
}

onMounted(() => {
  svgNodes.value = [...formStore.getAllStages]
  stage.width = connectorContainer.value.offsetWidth
  stage.height = connectorContainer.value.offsetHeight
})

</script>

<template>
  <div ref="connectorContainer" class="map-container">
    <svg
        ref="svg"
        :viewBox="`0 0 ${stage.width} ${stage.height}`"
        :width="stage.width"
        :height="stage.height"
    >
      <title class="map-title">{{ t('svg-map-title') }}</title>

      <defs>
        <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="15" refY="3.5" orient="auto">
          <polygon points="0 1, 5 3.5, 0 6" />
        </marker>
      </defs>

      <g ref="connectors" class="map-connectors">
        <SvgPath
            v-for="path in formStore.getAllConnectors"
            :connector="path"
            :key="path.id"
        />
      </g>

      <g ref="nodes" class="map-nodes">
        <SvgCircle
            v-for="item in formStore.getAllStages"
            :data="item"
            :key="item.id"
            @touchend="showQuestion(item)"
            @click="showQuestion(item)"
            @keyup.enter="showQuestion(item)"
            tabindex="0"
        />
      </g>
    </svg>
  </div>
</template>